import React from 'react';
import {LoadingIndicator} from "../../../core/components/loading/loading-indicator";
import styles from '../styles/bolao-container.module.scss';

export const BolaoContainerPlaceholder = () => {

  return (
    <div className={styles.loader}>
      <LoadingIndicator />
    </div>
  )
};
